
const randString = function randStringfunc(x) {
  let s = '';
  while (s.length < x && x > 0) {
    const r = Math.random();
    s += (r < 0.1 ? Math.floor(r * 100) : String.fromCharCode(Math.floor(r * 26) + (r > 0.5 ? 97 : 65)));
  }
  return s;
};

export default randString;



/** WEBPACK FOOTER **
 ** ./src/utils/codegenerator.js
 **/